<aside class="upload-panel" [class.upload-panel--expanded]="expanded()">
  @if (items.length > 0) {
  <div class="upload-panel__collapsed-bar" (click)="uploadProgress.togglePanelExpanded()" title="Expandir panel de subidas">
    <!-- <i class="bi bi-upload upload-panel__collapsed-icon" aria-hidden="true"></i>
    <span class="upload-panel__collapsed-label">Subidas</span> -->
    <button class="icon-btn" type="button" title="Subidas">
      <i class="bi bi-upload"></i>
    </button>
    @if (items.length > 0) {
    <div class="upload-panel__collapsed-dots">
      @for (item of reversedItems; track item.id) {
      <div class="upload-panel__collapsed-dot-wrap" [attr.title]="getItemTooltip(item)" [class.upload-panel__collapsed-dot-wrap--error]="item.error" [class.upload-panel__collapsed-dot-wrap--interrupted]="isInterrupted(item)">
        <div class="upload-panel__collapsed-dot" role="progressbar" [attr.aria-valuenow]="item.progress" aria-valuemin="0" aria-valuemax="100" [style.background]="getCircleProgressBg(item)"></div>
        @if (item.error) {
        <i class="bi bi-x upload-panel__collapsed-dot-icon" aria-hidden="true"></i>
        } @else if (item.completed) {
        <i class="bi bi-check upload-panel__collapsed-dot-icon upload-panel__collapsed-dot-icon--ok" aria-hidden="true"></i>
        } @else if (isInterrupted(item)) {
        <i class="bi bi-pause-fill upload-panel__collapsed-dot-icon upload-panel__collapsed-dot-icon--interrupted" aria-hidden="true"></i>
        }
      </div>
      }
    </div>
    }
  </div>
  <div class="upload-panel__content">
    <div class="upload-panel__header">
      <h3 class="upload-panel__title"><i class="bi bi-upload upload-panel__collapsed-icon" aria-hidden="true"></i> Subida de archivos</h3>
      @if (hasCompletedItems()) {
      <button type="button" class="upload-panel__btn-clear" (click)="removeCompleted()" aria-label="Borrar listado subidas" ngbTooltip="Borrar listado subidas">
        <i class="bi bi-x-circle"></i>
        <span class="visually-hidden">Borrar todo</span>
      </button>
      }
      <button type="button" class="upload-panel__btn-close" (click)="uploadProgress.togglePanelExpanded()" aria-label="Contraer panel" ngbTooltip="Contraer panel">
        <i class="bi bi-layout-sidebar-inset-reverse"></i>
      </button>
    </div>
    @if (hasUploadsInProgress()) {
    <p class="upload-panel__warning" role="alert" animate.enter="loaded-height-enter" animate.leave="loaded-height-leave">
      <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
      No cierre el navegador o se cortará la subida.
    </p>
    }
    <input #resumeFileInput type="file" class="upload-panel__file-input" (change)="onResumeFileSelected($event)" accept="*">
    <ul class="upload-panel__list">
      @for (item of reversedItems; track item.id) {
      <li class="upload-panel__item" [class.upload-panel__item--error]="item.error" [class.upload-panel__item--interrupted]="isInterrupted(item)" animate.enter="loaded-height-enter" animate.leave="loaded-height-leave">
        <div class="upload-panel__meta">
          <div class="upload-panel__filename" [title]="item.file.name">{{ item.file.name }}</div>
        </div>
        <div class="upload-panel__context">
          <div class="flex-row-wrap">
            <div><span class="upload-panel__label">{{ item.documentTitle }}</span></div>
            <div class="upload-panel__size"><i class="bi bi-archive"></i> {{ formatFileSize(item.file.size) }}</div>
          </div>
        </div>
        <div class="upload-panel__context">
          <div class="flex-row-wrap">
            <div><span class="upload-panel__label">Cliente:</span> {{ item.clientName }}</div>
            <div><span class="upload-panel__label">Proyecto:</span> {{ item.projectName }}</div>
          </div>
        </div>
        <div class="upload-panel__context">
          <div class="flex-row-wrap">
            <div><span class="upload-panel__label">Chatbot:</span> {{ item.chatName }}</div>
          </div>
        </div>

        <!-- Fila: botones + barra de progreso + % -->
        @if (item.progress < 100) { <div class="upload-panel__progress-wrap" animate.enter="loaded-height-enter" animate.leave="loaded-height-leave">
          <div class="upload-panel__progress-row">
            @if (isUploading(item)) {
            <!-- <span class="upload-panel__uploading" aria-hidden="true">
              <i class="bi bi-slash-circle upload-panel__spinner" aria-hidden="true"></i>
              Subiendo…
            </span> -->
            <div class="upload-panel__actions-inline">
              <button type="button" class="upload-panel__btn-pause" (click)="uploadProgress.pauseUpload(item.id)" title="Pausar (podrás reanudar después)">
                <i class="bi bi-pause-fill"></i>
              </button>
              <button type="button" class="upload-panel__btn-cancel" (click)="uploadProgress.cancelUpload(item.id)" title="Detener y quitar de la lista">
                <i class="bi bi-stop-fill"></i>
              </button>
            </div>
            }
            @if (item.error) {
            <div class="upload-panel__actions-inline">
              <button type="button" class="upload-panel__btn-resume" title="Reanudar" (click)="triggerResumeFileSelect(item)">
                <i class="bi bi-play"></i>
              </button>
              <button type="button" class="upload-panel__btn-cancel" (click)="cancelItem(item)" title="Cancelar y quitar de la lista">
                <i class="bi bi-x"></i>
              </button>
            </div>
            }
            @if (isInterrupted(item) && !item.error) {
            <div class="upload-panel__actions-inline">
              <button type="button" class="upload-panel__btn-resume" title="Reanudar" (click)="triggerResumeFileSelect(item)">
                <i class="bi bi-play"></i>
              </button>
              <button type="button" class="upload-panel__btn-cancel" (click)="cancelItem(item)" title="Cancelar y quitar de la lista">
                <i class="bi bi-x"></i>
              </button>
            </div>
            }
            <div class="upload-panel__progress-bar" role="progressbar" [attr.aria-valuenow]="item.progress" aria-valuemin="0" aria-valuemax="100">
              <div class="upload-panel__progress-fill" [style.width.%]="item.progress"></div>
            </div>
            <span class="upload-panel__progress-text">{{ item.progress }}%</span>
          </div>
  </div>
  }

  <!-- Footer del bloque: mensajes de estado (solo si hay algo que mostrar) -->
  @if (item.error || item.completed || isInterrupted(item) || getResumeError(item.id)) {
  <div class="upload-panel__item-footer" animate.enter="loaded-height-enter" animate.leave="loaded-height-leave">
    @if (item.error) {
    <div class="upload-panel__status upload-panel__status--error">
      <i class="bi bi-exclamation-triangle"></i> Error en la subida
    </div>
    } @else if (item.completed) {
    <div class="flex-row-wrap">
      <span class="upload-panel__status upload-panel__status--ok">
        <i class="bi bi-check-circle"></i> Completado
      </span>
      <span role="button" class="upload-panel__status upload-panel__status--remove" (click)="removeItemFromList(item)">
        <i class="bi bi-x-circle" ngbTooltip="Quitar de la lista" aria-label="Quitar de la lista"></i>
      </span>
    </div>
    } @else if (isInterrupted(item)) {
    <div class="upload-panel__status upload-panel__status--interrupted">
      <i class="bi bi-exclamation-triangle"></i> Subida interrumpida
    </div>
    }
    @if (getResumeError(item.id)) {
    <p class="upload-panel__resume-error-inline" role="alert">
      <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
      {{ getResumeError(item.id) }}
    </p>
    }
  </div>
  }
  </li>
  }
  </ul>
  </div>
  }
</aside>
